// extracted by mini-css-extract-plugin
module.exports = {"pymtDtl":"debit_pymtDtl__2UXRX"};